<w-input-text #text class="b-input-search" [placeholder]="placeholder" [(ngModel)]="value" (keydown)="keydown($event)"
    [disabled]="disabled"
    [maxlength]="maxLength"
    [minlength]="minLength"
    [pattern]="pattern"
    (keyup)="keyup($event)" [title]="tooltip" (wFocus)="inputFocus($event)" (wBlur)="processBlur($event)">
    <span facet-buttons (click)="clear()" class="b-workbench-filter__clear-search b-icon b-icon--close"
        [style.display]="value?'inline-block':'none'"></span>
    <button w-button buttonType="search" [size]="buttonSize" facet-buttons (click)="clickSearch()"
        [disabled]="disabled" tabindex="-1"
        style="margin:0;float:none;"></button>
    <!-- dropdown w triangle -->
    <w-input-dropdown *ngIf="showDropdown && !!dropdownText" [text]="dropdownText" [list]="dropdownList"
        [selected]="dropdownSelected" [activeIndex]="activeIndex" (wDropdownClick)="dropdownClick($event)"
        facet-dropdown-notice>
    </w-input-dropdown>
    <!-- dropdown w/o triangle -->
    <w-input-dropdown *ngIf="showDropdown && !dropdownText" [list]="dropdownList" [activeIndex]="activeIndex" 
        [selected]="dropdownSelected" (wDropdownClick)="dropdownClick($event)" facet-dropdown></w-input-dropdown>
    <ng-content select="f-facet[name=info],[facet-info]" facet-info></ng-content>
    <ng-content select="f-facet[name=error],[facet-error]" facet-error></ng-content>
    <ng-content select="f-facet[content],[facet-content]" facet-content></ng-content>
</w-input-text>